// Models
PJQ.models.schedule.Template = PJQ.models.BaseModel.extend({
    idAttribute: 'templateId',
    notifyName: 'Template',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'schedule'
            },
            {
                endpoint: 'templates',
                value: this.id
            }
        ], this.get('projectId') > 0 ? [
            {
                parameter: 'projectId',
                value: this.get('projectId')
            },
            {
                parameter: 'copyAssignees',
                value: this.get('copyAssignees')
            },
            {
                parameter: 'copyDependencies',
                value: this.get('copyDependencies')
            },
            {
                parameter: 'copyComments',
                value: this.get('copyComments')
            },
            {
                parameter: 'copyAttachments',
                value: this.get('copyAttachments')
            },
            {
                parameter: 'overwrite',
                value: this.get('overwrite')
            }
        ] : null);
    },
    parse: function (model) {
        if (!model)
            return model;

        if (model.project != null) {
            this.project = model.project;
        } else {
            this.user = PJQ.app.session.user;
        }

        this.statuses = new PJQ.collections.schedule.TaskStatuses(model.statuses);
        PJQ.app.session.scheduleTaskStatuses = this.statuses;

        this.dependencies = new PJQ.collections.schedule.TaskDependencies(model.dependencies);

        this.pendingRequestedChanges = new PJQ.collections.schedule.RequestedChanges(model.requestedChanges);

        this.tasks = new PJQ.collections.schedule.Tasks();
        if (model.tasks) {
            _.each(model.tasks, function (task) {
                this.tasks.add(new this.tasks.model(_.defaults({
                    status: task.status != null ? task.status : this.statuses.get(task.statusId),
                    requestedChanges: _.filter(this.pendingRequestedChanges.models, function (dependency) {
                        return dependency.get('taskId') === task.taskId;
                    }),
                    dependencies: _.filter(this.dependencies.models, function (dependency) {
                        return dependency.get('taskId') === task.taskId || dependency.get('dependTaskId') === task.taskId;
                    })
                }, task)));
            }, this);
        }

        return model;
    }
});

PJQ.models.schedule.LookAhead = PJQ.models.BaseModel.extend({
    idAttribute: 'id',
    notifyName: 'Look-Ahead',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.get('projectId')
            },
            {
                endpoint: 'schedule'
            },
            {
                endpoint: 'lookaheads',
                value: this.id
            }
        ]);
    },
    parse: function (model) {
        if (!model)
            return model;

        if (model.project != null) {
            this.project = model.project;
        } else {
            this.user = PJQ.app.session.user;
        }

        if(model.statuses != null && model.statuses.length > 0) {
            this.statuses = new PJQ.collections.schedule.TaskStatuses(model.statuses);
            PJQ.app.session.scheduleTaskStatuses = this.statuses;
        } else if (PJQ.app.session.scheduleTaskStatuses != null && PJQ.app.session.scheduleTaskStatuses?.length > 0) {
            this.statuses = PJQ.app.session.scheduleTaskStatuses;
        }

        this.dependencies = new PJQ.collections.schedule.TaskDependencies(model.dependencies);

        this.pendingRequestedChanges = new PJQ.collections.schedule.RequestedChanges(model.requestedChanges);

        this.tasks = new PJQ.collections.schedule.Tasks();
        if (model.tasks) {
            _.each(model.tasks, function (task) {
                this.tasks.add(new this.tasks.model(_.defaults({
                    status: task.status != null ? task.status : this.statuses.get(task.statusId),
                    requestedChanges: _.filter(this.pendingRequestedChanges.models, function (dependency) {
                        return dependency.get('taskId') === task.taskId;
                    }),
                    dependencies: _.filter(this.dependencies.models, function (dependency) {
                        return dependency.get('taskId') === task.taskId || dependency.get('dependTaskId') === task.taskId;
                    })
                }, task)));
            }, this);
        }

        return model;
    },
    getDisplayName: function (actual) {
        let start, finish;
        if (actual) {
            start = new Date(this.get('tasksStart'));
            finish = new Date(this.get('tasksFinish'));
            if (start == null || finish == null) {
                return "";
            }
        } else {
            start = new Date(this.get('start'));
            finish = PJQ.helpers.dateHelpers.getNewDateAddDays(start, this.get('duration'));
        }

        let startStr = PJQ.helpers.dateHelpers.getDateString(start, PJQ.helpers.dateHelpers.dateFormats.DATE, true),
            finishStr = PJQ.helpers.dateHelpers.getDateString(finish, PJQ.helpers.dateHelpers.dateFormats.DATE, true);
        return startStr + ' - ' + finishStr;
    },
    share: function (shareData, callback) {
        let sh = new PJQ.models.schedule.ScheduleShare(_.defaults(shareData ? shareData : {}, {
            projectId: this.get('projectId'),
            lookAheadId: this.id
        }));
        sh.save(null, {
            success: function () {
                if (typeof callback === 'function') {
                    callback(sh);
                }
            }
        });
    }
});

PJQ.models.schedule.ScheduleShare = PJQ.models.BaseModel.extend({
    idAttribute: 'accessKey',
    notifyName: 'Schedule',
    endpoint: function () {
        if (this.get('projectId') > 0) {
            let params = [];
            if (this.get('lookAheadId') > 0) {
                params.push({
                    parameter: 'lookAheadId',
                    value: this.get('lookAheadId')
                });
            }

            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.get('projectId')
                },
                {
                    endpoint: 'schedule'
                },
                {
                    endpoint: 'share'
                }
            ], params);
        }
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'schedule'
            },
            {
                endpoint: 'share',
                value: this.id
            }
        ]);
    }
});

PJQ.models.schedule.Schedule = PJQ.models.schedule.Template.extend({
    notifyName: 'Schedule',
    endpoint: function () {
        let arr;
        if (this.get('projectId') != null) {
            arr = [
                {
                    endpoint: 'projects',
                    value: this.get('projectId')
                },
                {
                    endpoint: 'schedule'
                }
            ];
        } else {
            arr = [
                {
                    endpoint: 'schedule'
                }
            ];
        }
        return PJQ.helpers.urlHelpers.generateEndpoint(arr);
    },
    share: function (shareData, callback) {
        let sh = new PJQ.models.schedule.ScheduleShare(_.defaults(shareData ? shareData : {}, {
            projectId: this.get('projectId')
        }));
        sh.save(null, {
            success: function () {
                if (typeof callback === 'function') {
                    callback(sh);
                }
            }
        });
    }
});

PJQ.models.schedule.Task = PJQ.models.BaseModel.extend({
    notifyName: 'Task',
    idAttribute: 'taskId',
    endpoint: function (urlOptions) {
        let arr;
        if (this.isNew() && this.get('projectId') > 0) {
            arr = [
                {
                    endpoint: 'projects',
                    value: this.get('projectId')
                },
                {
                    endpoint: 'schedule'
                },
                {
                    endpoint: 'tasks'
                }
            ];
        } else if (this.isNew() && this.get('templateId') > 0) {
            arr = [
                {
                    endpoint: 'schedule'
                },
                {
                    endpoint: 'templates',
                    value: this.get('templateId')
                },
                {
                    endpoint: 'tasks'
                }
            ];
        } else {
            arr = [
                {
                    endpoint: 'schedule'
                },
                {
                    endpoint: 'tasks',
                    value: this.id
                }
            ]
        }
        return PJQ.helpers.urlHelpers.generateEndpoint(arr)
    },
    parse: function (model) {
        model = _.defaults(model ? model : {}, {
            name: "",
            duration: 1,
            start: null,
            finish: null,
            weekendWork: false,
            isAllDay: true,
            isMilestone: false,
            percentComplete: 0,
            notes: "",
            lookAheadId: null,
            projectId: null,
            templateId: null
        });

        //if the parsed value is an array, this was a save response that returned multiple tasks
        //the multiple tasks are returned because dependency relationships caused other tasks to be modified
        if (model.changes != null) {
            this.set('taskId', model.task.taskId);
            if (this.collection != null) {
                _.each(model.changes, function (task) {
                    let colTask = this.collection.get(task.taskId);
                    if(colTask == null){
                        return;
                    }

                    task.start = PJQ.helpers.dateHelpers.parseDateString(task.start, false);
                    task.finish = PJQ.helpers.dateHelpers.parseDateString(task.finish, false);
                    colTask.set({
                        start: task.start,
                        finish: task.finish
                    });
                }, this);
            }
            model = model.task;
        }

        if (model.subTasks != null) {
            this.subTasks = new PJQ.collections.schedule.Tasks(model.subTasks);
        }

        if (model.project != null) {
            this.project = model.project;
        }

        if (model.status != null) {
            this.status = model.status;
        } else if ((PJQ.app.session.scheduleTaskStatuses != null)) {
            if (model.statusId > 0) {
                this.status = PJQ.app.session.scheduleTaskStatuses.get(model.statusId);
            } else {
                this.status = PJQ.app.session.scheduleTaskStatuses.getDefault();
            }
        }

        if (_.size(model.start) > 0) {
            model.start = typeof model.start === 'string' ? PJQ.helpers.dateHelpers.parseDateString(model.start, false) : model.start;
        }

        if (_.size(model.finish) > 0) {
            model.finish = typeof model.finish === 'string' ? PJQ.helpers.dateHelpers.parseDateString(model.finish, false) : model.finish;
        }

        this.assignees = new PJQ.collections.projectContacts.ProjectContacts(model.assignees);
        this.groups = new PJQ.collections.groups.Groups(model.groups);
        this.comments = new PJQ.collections.schedule.TaskComments(model.comments);
        this.attachments = new PJQ.collections.schedule.ScheduleTaskAttachments(model.attachments);

        if (PJQ.helpers.objectHelpers.refinedType(model.requestedChanges, true) === 'backboneCollection') {
            this.requestedChanges = model.requestedChanges;
        } else {
            this.requestedChanges = new PJQ.collections.schedule.RequestedChanges(model.requestedChanges);
        }

        if (_.size(model.dependencies) > 0) {
            if (PJQ.helpers.objectHelpers.refinedType(model.dependencies, true) === 'backboneCollection') {
                this.dependencies = model.dependencies;
            } else {
                this.dependencies = new PJQ.collections.schedule.TaskDependencies(model.dependencies);
            }
        } else if (this.dependencies == null) {
            this.dependencies = new PJQ.collections.schedule.TaskDependencies();
        }

        return model;
    },
    getSummaryTaskName: function (tasks) {
        let summaryTaskId = this.get('summaryTaskId'),
            name = '';
        if (summaryTaskId > 0) {
            let summaryTask = tasks.get(this.get('summaryTaskId'));
            if (summaryTask != null) {
                name += summaryTask.getSummaryTaskName(tasks) + summaryTask.get('name') + ' > ';
            }
        }
        return name;
    },
    getMinStart: function () {
        if (this.collection == null) {
            return null;
        }

        let deps = this.getDependencies();
        if (_.size(deps) === 0) {
            return null;
        }

        return _.max(_.map(deps, function (dep) {
            let depTask = this.collection.get(dep.get('dependTaskId'));
            if (dep.get('type') === PJQ.constants.schedule.dependencyTypes.START_START) {
                if (dep.get('offset') !== 0) {
                    return depTask.get('start');
                }
                return PJQ.helpers.dateHelpers.getNewDateAddDays(depTask.get('finish'), dep.get('offset'), !this.get('weekendWork'));
            } else if (dep.get('type') === PJQ.constants.schedule.dependencyTypes.FINISH_START) {
                return PJQ.helpers.dateHelpers.getNewDateAddDays(depTask.get('finish'), 1 + dep.get('offset'), !this.get('weekendWork'));
            }
            return null;
        }, this));
    },
    getDependencies: function () {
        return _.filter(this.dependencies.models, function (dependency) {
            return dependency.get('taskId') === this.id && !dependency.get('isDeleted');
        }, this);
    },
    getSuccessors: function () {
        return _.filter(this.dependencies.models, function (dependency) {
            return dependency.get('dependTaskId') === this.id && !dependency.get('isDeleted');
        }, this);
    },
    updateWeekendWork: function (weekendWork) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'schedule'
                },
                {
                    endpoint: 'tasks',
                    value: this.get('taskId')
                },
                {
                    endpoint: 'updateweekendwork'
                },
            ], [
                {
                    parameter: 'weekendWork',
                    value: weekendWork
                }
            ]),
            data: { cloudFlareFix: true }
        }).put().done(_.bind(function () {
            this.set('weekendWork', weekendWork);
        }, this));
    },
    determineChangedTasks: function (assignedOnly = true) {
        let result = [],
            resultIds = [],
            fnCheckDeps = _.bind(function (taskData) {
                _.each(taskData.task.getSuccessors(), function (successor) {
                    if (resultIds.indexOf(successor.get('taskId')) !== -1) {
                        return;
                    }

                    let successorTask = this.collection.get(successor.get('taskId')),
                        cTaskData = null;
                    if (assignedOnly && _.size(successorTask.assignees) === 0) {
                        return;
                    }

                    if (successor.get('type') === PJQ.constants.schedule.dependencyTypes.FINISH_START && PJQ.helpers.dateHelpers.getDateDaysDiff(successorTask.get('start'), taskData.newFinish, !successorTask.get('weekendWork')) <= 0) {
                        let newStart = PJQ.helpers.dateHelpers.getNewDateAddDays(taskData.newFinish, 1, !successorTask.get('weekendWork'));
                        cTaskData = {
                            task: successorTask,
                            newStart: newStart,
                            newFinish: PJQ.helpers.dateHelpers.getNewDateAddDays(newStart, successorTask.get('duration'), !successorTask.get('weekendWork'), true)
                        };
                    } else if (successor.get('type') === PJQ.constants.schedule.dependencyTypes.START_START && PJQ.helpers.dateHelpers.getDateDaysDiff(successorTask.get('start'), taskData.newStart, !successorTask.get('weekendWork')) <= 0) {
                        cTaskData = {
                            task: successorTask,
                            newStart: taskData.newStart,
                            newFinish: PJQ.helpers.dateHelpers.getNewDateAddDays(taskData.newStart, successorTask.get('duration'), !successorTask.get('weekendWork'), true)
                        };
                    }
                    if (cTaskData != null) {
                        result.push(cTaskData);
                        resultIds.push(successor.get('taskId'));
                        fnCheckDeps(cTaskData);
                    }
                }, this);
            }, this);

        if (this.id > 0 && (!assignedOnly || _.size(this.assignees) > 0) && (0 !== PJQ.helpers.dateHelpers.getDateDaysDiff(this.initAttributes.start, this.attributes.start, false) || 0 !== PJQ.helpers.dateHelpers.getDateDaysDiff(this.initAttributes.finish, this.attributes.finish, false))) {
            result.push({
                task: this,
                newStart: this.get('start'),
                newFinish: this.get('finish')
            });
            resultIds.push(this.id);
        }
        fnCheckDeps({
            task: this,
            newStart: this.get('start'),
            newFinish: this.get('finish')
        });
        return result;
    },
    getGanttTask: function () {
        return new PJQ.models.charts.GanttTask({
            id: this.id,
            model: this,
            name: this.get('name'),
            start: this.get('start'),
            end: this.get('finish'),
            duration: this.get('duration'),
            isMilestone: this.get('isMilestone'),
            thumbnail: this.get('isMilestone') ? 'https://app.panteratools.com//assets/libs/svgs/light/flag.svg' : null,
            progress: this.get('percentComplete'),
            dependencies: _.map(this.getDependencies(), function (dep) {
                return dep.get('dependTaskId');
            }),
            style: this.status != null ? 'fill: ' + this.status.get('color') : 'fill: #6c757d',
            textColor: '#4CAF50'
        });
    },
    getCalendarTask: function (tasks) {
        return new PJQ.models.calendars.CalendarTask({
            id: this.id,
            model: this,
            title: this.getCalendarTaskTitle(tasks),
            isMilestone: this.get('isMilestone'),
            start: this.get('start'),
            progress: this.get('percentComplete'),
            end: PJQ.helpers.dateHelpers.getNewDateAddDays(this.get('finish'), 1),
            allDay: this.get('isAllDay'),
            backgroundColor: (this.status ? this.status.get('color') : '#6c757d') + ' !important',
            borderColor: (this.status ? this.status.get('color') : '#6c757d') + ' !important'
        });
    },
    getCalendarTaskTitle: function (tasks) {
        let name = this.getSummaryTaskName(tasks) + this.get('name'),
            assigneesArray = [];
        _.each(this.assignees.models, function (assignee) {
            let cName = _.size(assignee.get('contactName')) > 0 ? assignee.get('contactName') : assignee.get('companyName');
            if (_.size(cName) > 0) {
                assigneesArray.push(cName);
            }
        }, this)

        if (_.size(assigneesArray) >= 1) {
            return name + " (" + assigneesArray.join(', ') + ')';
        } else {
            return name;
        }
    },
    beforeSave: function () {
        this.set('statusId', this.status != null ? this.status.id : 0);
        this.set('assignees', this.assignees.toJSON());
        this.set('groups', this.groups.toJSON());
        this.set('dependencies', this.dependencies.getChangedModels());
        this.set('requestedChanges', this.requestedChanges.getChangedModels());
        this.set('attachments', this.attachments.getChangedModels());
    },
    afterSave: function () {
        if (this.collection != null) {
            _.each(this.dependencies.models, function (dep) {
                let relTaskId;
                if (dep.get('taskId') !== this.id) {
                    relTaskId = dep.get('taskId');
                } else {
                    relTaskId = dep.get('dependTaskId');
                }

                let relTask = this.collection.get(relTaskId);
                if (relTask != null) {
                    let relDep = relTask.dependencies.where({
                        taskId: dep.get('taskId'),
                        dependTaskId: dep.get('dependTaskId')
                    });
                    if (relDep == null && !dep.get('isDeleted')) {
                        relTask.dependencies.add(dep);
                    } else if (dep.get('isDeleted')) {
                        relTask.dependencies.remove(dep);
                    }
                }
            }, this);
        }
    },
    fetchNotifications: function (callback) {
        if (this.notifications == null) {
            this.notifications = new PJQ.collections.schedule.Notifications(null, {
                taskId: this.id
            })
        }

        this.notifications.fetch({
            success: _.bind(function () {
                callback(this.notifications);
            }, this)
        });
    },
    newDependencyTask: function () {
        let start = PJQ.helpers.dateHelpers.getNewDateAddDays(this.get('start'), -1, !this.get('weekendWork')),
            newTask = new PJQ.models.schedule.Task({
                projectId: this.get('projectId'),
                templateId: this.get('templateId'),
                start: start,
                finish: start
            });
        newTask.dependencies.add({
            taskId: this.id,
            dependTaskId: newTask.id,
            type: PJQ.constants.schedule.dependencyTypes.FINISH_START,
            offset: 0
        });
        return newTask;
    },
    newSuccessorTask: function () {
        let start = PJQ.helpers.dateHelpers.getNewDateAddDays(this.get('finish'), 1, !this.get('weekendWork')),
            newTask = new PJQ.models.schedule.Task({
                projectId: this.get('projectId'),
                templateId: this.get('templateId'),
                start: start,
                finish: start
            });
        newTask.dependencies.add({
            taskId: newTask.id,
            dependTaskId: this.id,
            type: PJQ.constants.schedule.dependencyTypes.FINISH_START,
            offset: 0
        });
        return newTask;
    }
});

PJQ.models.schedule.TaskDependency = PJQ.models.BaseModel.extend({
    notifyName: 'Dependency',
    idAttribute: 'dependencyId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'schedule'
            },
            {
                endpoint: 'tasks',
                value: this.get('taskId')
            },
            {
                endpoint: 'dependencies',
                value: this.id
            }
        ]);
    },
    getTooltip: function (tasks) {
        let result,
            dependTask = _.find(tasks.models, function (task) {
                return this.get('dependTaskId') === task.id;
            }, this),
            task = _.find(tasks.models, function (task) {
                return this.get('taskId') === task.id;
            }, this);
        if (this.get('offset') > 0 || this.get('offset') < 0) {
            result = task.get('name') + ' can start no earlier than ' + (this.get('offset') > 0 ? (this.get('offset') + ' days after ') : (-this.get('offset') + ' days before ')) + dependTask.get('name') + (this.get('type') === PJQ.constants.schedule.dependencyTypes.FINISH_START ? ' finishes' : ' starts');
        } else {
            result = dependTask.get('name') + ' must ' + (this.get('type') === PJQ.constants.schedule.dependencyTypes.FINISH_START ? 'finish' : 'start') + ' before ' + task.get('name') + ' can start';
        }
        return result;
    }
});

PJQ.models.schedule.RequestedChange = PJQ.models.BaseModel.extend({
    notifyName: 'Requested Change',
    idAttribute: 'changeId',
    endpoint: function () {
        if (this.id > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'schedule'
                },
                {
                    endpoint: 'changes',
                    value: this.id
                }
            ]);
        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'schedule'
            },
            {
                endpoint: 'tasks',
                value: this.get('taskId')
            },
            {
                endpoint: 'changes'
            }
        ]);
    },
    parse: function (model) {
        if (!model) {
            return model;
        }

        if (model.newStart != null) {
            model.newStart = PJQ.helpers.dateHelpers.parseDateString(model.newStart, false);
            model.newFinish = PJQ.helpers.dateHelpers.parseDateString(model.newFinish, false);
        }

        if (model.oldStart != null) {
            model.oldStart = PJQ.helpers.dateHelpers.parseDateString(model.oldStart, false);
            model.oldFinish = PJQ.helpers.dateHelpers.parseDateString(model.oldFinish, false);
        }
        return model;
    },
    approve: function (callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/approve',
            data: this.toJSON()
        }).post().done(_.bind(function (response) {
            this.set(response.requestedChange);
            if (typeof callback === 'function') {
                callback(response);
            }
        }, this));
    },
    reject: function (callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/reject',
            data: this.toJSON()
        }).post().done(_.bind(function (response) {
            this.set(response);
            if (typeof callback === 'function') {
                callback(response);
            }
        }, this));
    },
});

PJQ.models.schedule.TaskStatus = PJQ.models.BaseModel.extend({
    notifyName: 'Status',
    idAttribute: 'statusId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'schedule'
            },
            {
                endpoint: 'statuses',
                value: this.id
            }
        ]);
    }
});

PJQ.models.schedule.ScheduleTaskAttachment = PJQ.models.files.File.extend({
    idAttribute: 'attachmentId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'schedule'
            },
            {
                endpoint: 'tasks',
                value: this.get('taskId')
            },
            {
                endpoint: 'attachments',
                value: this.id
            }
        ]);
    }
});

PJQ.models.schedule.TaskComment = PJQ.models.BaseModel.extend({
    notifyName: 'Comment',
    idAttribute: 'commentId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'schedule'
            },
            {
                endpoint: 'tasks',
                value: this.get('taskId')
            },
            {
                endpoint: 'comments',
                value: this.id
            }
        ]);
    },
    parse: function (model) {
        if (!model) {
            return model;
        }
        if (model.createdBy != null) {
            this.createdBy = new PJQ.models.projectContacts.ProjectContact(model.createdBy);
        }
        return model;
    }
});

PJQ.models.schedule.Settings = PJQ.models.BaseModel.extend({
    notifyName: 'Schedule Settings',
    idAttribute: 'userId',
    endpoint: function () {
        if (this.get('projectId') > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.get('projectId')
                },
                {
                    endpoint: 'schedule'
                },
                {
                    endpoint: 'settings'
                }
            ]);
        }
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'schedule'
            },
            {
                endpoint: 'settings'
            }
        ]);
    },
    parse: function (model) {
        if (!model) {
            return model;
        }

        this.lookAheadManagers = new PJQ.collections.projectContacts.ProjectContacts(model.lookAheadManagers);
        return model;
    },
    beforeSave: function () {
        this.set('lookAheadManagers', this.lookAheadManagers.toJSON());
    },
});

PJQ.models.schedule.TaskListItemGroup = PJQ.models.BaseModel.extend({});

// Collections
PJQ.collections.schedule.Templates = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.schedule.Template,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'schedule'
            },
            {
                endpoint: 'templates'
            }
        ]);
    }
});

PJQ.collections.schedule.LookAheads = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.schedule.LookAhead,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.projectId
            },
            {
                endpoint: 'schedule'
            },
            {
                endpoint: 'lookaheads'
            }
        ]);
    }
});

PJQ.collections.schedule.Tasks = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.schedule.Task,
    getGanttTasks: function () {
        let sortedModels = _.sortBy(this.models, function (model) {
            if (model.get('start') != null) {
                return new Date(model.get('start'));
            }
        });
        let fnGetSubtasks = _.bind(function (task) {
                let subTasks = _.filter(sortedModels, function (model) {
                    return model.get('summaryTaskId') === task.id && model.id !== task.id;
                });
                _.each(subTasks, function (subTask) {
                    subTasks.push(...fnGetSubtasks(subTask));
                });
                return subTasks;
            }, this),
            tasks = [];
        _.each(sortedModels, function (model) {
            if (model.get('summaryTaskId') > 0) {
                return;
            }

            tasks.push(model.getGanttTask());
            _.each(fnGetSubtasks(model), function (subTask) {
                tasks.push(subTask.getGanttTask());
            })
        });
        return new PJQ.collections.charts.GanttTasks(tasks);
    },
    getCalendarTasks: function () {
        return new PJQ.collections.calendars.CalendarTasks(_.map(_.filter(this.models, function (model) {
            return !model.get('isSummaryTask');
        }), function (model) {
            return model.getCalendarTask(this);
        }, this));
    },
    getValidDependencies: function (task, explicitAllow = null) {
        // tasks that cannot be dependencies:
        // existing successors (recursively)
        // dependencies that already exist
        let invalidTaskIds = [],
            fnCheck = _.bind(function (deps) {
                _.each(deps, function (dep) {
                    let tId = dep.get('taskId');
                    invalidTaskIds.push(tId);
                    fnCheck(this.get(tId).getSuccessors());
                }, this);
            }, this);
        fnCheck(task.getSuccessors());
        invalidTaskIds.push(..._.map(task.getDependencies(), function (dep) {
            return dep.get('dependTaskId');
        }));
        return _.filter(this.models, function (checkTask) {
            return (explicitAllow != null && explicitAllow === checkTask.id) || (checkTask.id !== task.id && invalidTaskIds.indexOf(checkTask.id) === -1);
        });
    },
    getValidSuccessors: function (task, explicitAllow = null) {
        // tasks that cannot be successors:
        // existing dependencies (recursively)
        // successors that already exist
        let invalidTaskIds = [],
            fnCheck = _.bind(function (deps) {
                _.each(deps, function (dep) {
                    let tId = dep.get('dependTaskId');
                    invalidTaskIds.push(tId);
                    fnCheck(this.get(tId).getDependencies());
                }, this);
            }, this);
        fnCheck(task.getDependencies());
        invalidTaskIds.push(..._.map(task.getSuccessors(), function (dep) {
            return dep.get('taskId');
        }));
        return _.filter(this.models, function (checkTask) {
            return (explicitAllow != null && explicitAllow === checkTask.id) || checkTask.id !== task.id && invalidTaskIds.indexOf(checkTask.id) === -1;
        });
    }
});

PJQ.models.schedule.ScheduleCustomField = PJQ.models.customFields.CustomField.extend({
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'schedule'
            },
            {
                endpoint: 'customFields',
                value: this.id
            }
        ])
    }
});

PJQ.models.schedule.Notification = PJQ.models.notifications.Notification.extend({
    notificationTypeNames: PJQ.constants.schedule.notificationTypeNames,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'schedule'
            },
            {
                endpoint: 'tasks',
                value: this.get('taskId') ? this.get('taskId') : this.collection.options.task.id
            },
            {
                endpoint: 'notifications',
                value: this.id
            }
        ])
    }
});

//Collections
PJQ.collections.schedule.TaskDependencies = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.schedule.TaskDependency
});

PJQ.collections.schedule.RequestedChanges = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.schedule.RequestedChange
});

PJQ.collections.schedule.TaskStatuses = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.schedule.TaskStatus,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'schedule'
            },
            {
                endpoint: 'statuses'
            }
        ]);
    },
    getDefault: function () {
        let def = this.findWhere({isDefault: true});
        if (def == null && this.length > 0) {
            def = this.models[0];
        }
        return def != null ? def : null;
    },
    copy: function (callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'schedule'
                },
                {
                    endpoint: 'statuses'
                },
                {
                    endpoint: 'copy'
                }
            ])
        }).post().done(_.bind(function (statuses) {
            this.reset(statuses);
            callback();
        }, this));

    }
});

PJQ.collections.schedule.TaskComments = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.schedule.TaskComment
});

PJQ.collections.schedule.ScheduleTaskAttachments = PJQ.collections.files.Files.extend({
    model: PJQ.models.schedule.ScheduleTaskAttachment
});

PJQ.collections.schedule.ScheduleCustomFields = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.schedule.ScheduleCustomField,
    options: {
        masterUserId: null
    },
    endpoint: function () {
        let arr;
        if (this.get('projectId') != null) {
            arr = [
                {
                    endpoint: 'projects',
                    value: this.options.project ? this.options.project.id : null
                },
                {
                    endpoint: 'schedule'
                },
                {
                    endpoint: 'customFields'
                }
            ];
        } else {
            arr = [
                {
                    endpoint: 'schedule'
                },
                {
                    endpoint: 'customFields'
                }
            ];
        }
        return PJQ.helpers.urlHelpers.generateEndpoint(arr);
    }
});

PJQ.collections.schedule.Notifications = PJQ.collections.notifications.Notifications.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.schedule.Notification,
    endpoint: function () {
        if (this.options.projectId > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.projectId
                },
                {
                    endpoint: 'schedule'
                },
                {
                    endpoint: 'notifications'
                }
            ]);
        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'schedule'
            },
            {
                endpoint: 'tasks',
                value: this.options.taskId
            },
            {
                endpoint: 'notifications'
            }
        ]);
    }
});
